import React, { useState, useEffect } from 'react';
const API_BASE = process.env.REACT_APP_API_URL + '/api';

console.log('🔍 API_BASE:', API_BASE);

function RegisterSimple({ selectedApp }) {
  const [form, setForm] = useState({
  name: '',
  email: '',
  password: '',
  contractAssignments: [{ contractId: '', pbpId: '' }],
  departmentId: '',
  memoRole: '',
  capRole: '',
  scrubberRole: '',
  riskRole: '',
  scrubberScopes: ['ODAG', 'CDAG', 'FA', 'SNPCC'] // Compliance admins get all protocols by default
});



  const [contracts, setContracts] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [pbpsByContract, setPbpsByContract] = useState({});
  const [message, setMessage] = useState('');
  // CAP matching mode: 'same' = use the Memo person; 'new' = create a separate CAP person
const [capMatch, setCapMatch] = useState('same');

// Separate CAP person fields (only used when capMatch === 'new')
const [capPerson, setCapPerson] = useState({
  name: '',
  email: '',
  password: '',
  departmentId: '',
  contractId: ''
});

  useEffect(() => {
  const fetchSession = async () => {
    try {
      const res = await fetch(`${API_BASE}/auth/session`, {
        credentials: 'include'
      });
      const data = await res.json();
      if (data.user?.organization_id) {
        sessionStorage.setItem('organization_id', data.user.organization_id);
        console.log('✅ Stored organization_id:', data.user.organization_id);
      } else {
        console.warn('⚠️ No organization_id in session');
      }
    } catch (err) {
      console.error('❌ Failed to fetch session:', err.message);
    }
  };
  fetchSession();
}, []);

// Local app box selections (click-to-enable sections)
const [appSelect, setAppSelect] = useState({
  memo: selectedApp === 'memo' || !selectedApp, // default Memo open
  cap: selectedApp === 'cap',
  scrubber: selectedApp === 'scrubber',
  risk: false
});

const toggleApp = (key) => {
  setAppSelect(prev => ({ ...prev, [key]: !prev[key] }));
};

useEffect(() => {
  const loadContracts = async () => {
    try {
      console.log('🔍 API_BASE:', API_BASE);
      console.log('📡 FETCH →', `${API_BASE}/contracts`);

      const res = await fetch(`${API_BASE}/contracts`, {
        credentials: 'include'
      });

      console.log('📥 HTTP STATUS:', res.status);
      const raw = await res.text();
      console.log('🧨 RAW RESPONSE:', raw);

      if (!res.ok) {
        throw new Error(`❌ HTTP ${res.status} — ${raw}`);
      }

      const data = JSON.parse(raw);
      if (data.success) setContracts(data.contracts);
    } catch (err) {
      console.error('❌ Failed to load contracts:', err.message);
    }
  };

  loadContracts();
}, []);

useEffect(() => {
  const loadDepartments = async () => {
    try {
      console.log('📡 FETCH →', `${API_BASE}/departments/with-aliases`);

      const res = await fetch(`${API_BASE}/departments/with-aliases`, {
        credentials: 'include'
      });

      const raw = await res.text();
      console.log('🧨 RAW RESPONSE (departments):', raw);

      if (!res.ok) {
        throw new Error(`❌ HTTP ${res.status} — ${raw}`);
      }

      const data = JSON.parse(raw);
      setDepartments(data.filter(d => d.submitted));
    } catch (err) {
      console.error('❌ Failed to load departments:', err.message);
    }
  };

  loadDepartments();
}, []);


  const handleAssignmentChange = async (idx, field, value) => {
    const updated = [...form.contractAssignments];
    updated[idx][field] = value;
    if (field === 'contractId') {
      updated[idx].pbpId = ''; // reset pbp if contract changes

      // fetch pbps if not already fetched
      if (!pbpsByContract[value]) {
        try {
const res = await fetch(`${API_BASE}/contracts/${value}/pbps`, { credentials: 'include' });

          const data = await res.json();
          console.log('✅ CONTRACT RESPONSE:', data);

       if (data.success) {
  setPbpsByContract(prev => ({ ...prev, [value]: data.pbps.map(p => ({ id: p.id, pbp: p.pbp })) }));
}

        } catch (err) {
          console.error('❌ Failed to load PBPs for contract:', value);
        }
      }
    }
    setForm({ ...form, contractAssignments: updated });
  };

  const addAssignment = () => {
    setForm({ ...form, contractAssignments: [...form.contractAssignments, { contractId: '', pbpId: '' }] });
  };

  const removeAssignment = (idx) => {
    const updated = [...form.contractAssignments];
    updated.splice(idx, 1);
    setForm({ ...form, contractAssignments: updated });
  };
const showDepartmentField = appSelect.memo;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

const handleCapPersonChange = (e) => {
  const { name, value } = e.target;
  setCapPerson(prev => ({ ...prev, [name]: value }));
};



  const handleRegister = async (e) => {
    e.preventDefault();
// If CAP is enabled and we're creating a separate CAP person, validate those fields
if (appSelect.cap && capMatch === 'new') {
  if (
    !capPerson.name ||
    !capPerson.email ||
    !capPerson.password ||
    !capPerson.departmentId ||
    !capPerson.contractId
  ) {
    setMessage('❌ Fill CAP name, email, password, department, and contract');
    return;
  }
}

// Clean department value for app_roles
const cleanedDeptId = ['admin', 'associate'].includes(form.memoRole) ? null : (form.departmentId || null);

const payload = {
  name: form.name,
  email: form.email,
  password: form.password,
  contractAssignments: form.contractAssignments,
  departmentId: cleanedDeptId,
  organization_id: sessionStorage.getItem('organization_id') || '',
  role: appSelect.memo ? form.memoRole : (appSelect.cap ? 'cap_user' : ''),  // ✅ top-level role required
  app_roles: {
    ...(appSelect.memo && {
      memo: {
        role: form.memoRole,
        department_id: cleanedDeptId,
        contract_id: form.contractAssignments?.[0]?.contractId || null,
        pbp_id: form.contractAssignments?.[0]?.pbpId || null
      }
    }),
    ...(appSelect.cap && {
      cap: {
        role: form.capRole,
        department_id: cleanedDeptId,
        contract_id: form.contractAssignments?.[0]?.contractId || null
      }
    }),
    ...(appSelect.scrubber && {
      scrubber: {
        role: form.scrubberRole
      }
    }),
    ...(appSelect.risk && {
      risk: {
        role: form.riskRole
      }
    })
  }
};



console.log('🧠 Final RegisterSimple payload:', JSON.stringify(payload, null, 2));




    try {
const res = await fetch(`${API_BASE}/users/simple`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  credentials: 'include',
  body: JSON.stringify(payload)
});




      const data = await res.json();
if (data.success) {
  console.log('✅ User created:', data.userId);

if (appSelect.cap) {
  if (capMatch === 'same') {
    // Assign CAP role to the same person created above
    const capRoleRes = await fetch(`${API_BASE}/app-roles/cap`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        user_id: data.userId,
        role: form.capRole,
        department_id: form.departmentId || null,
        contract_id: form.contractAssignments?.[0]?.contractId || null,
        organization_id: sessionStorage.getItem('organization_id') || ''
      })
    });
    if (!capRoleRes.ok) {
      const txt = await capRoleRes.text();
      throw new Error(`CAP role assign failed: ${capRoleRes.status} ${txt}`);
    }
  } else {
    // Create a separate CAP user, then assign CAP role to that user
    const capCreateRes = await fetch(`${API_BASE}/users/simple`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        name: capPerson.name,
        email: capPerson.email,
        password: capPerson.password,
        organization_id: sessionStorage.getItem('organization_id') || '',
        departmentId: capPerson.departmentId || null,
        role: 'cap_user' // satisfy backend required field
      })
    });
    const capCreate = await capCreateRes.json();
    if (!capCreateRes.ok || !capCreate?.userId) {
      const txt = await capCreateRes.text?.();
      throw new Error(`CAP user create failed: ${capCreateRes.status} ${txt || capCreate?.message || ''}`);
    }

    const capRoleRes = await fetch(`${API_BASE}/app-roles/cap`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        user_id: capCreate.userId,
        role: form.capRole,
        department_id: capPerson.departmentId || null,
        contract_id: capPerson.contractId || null,
        organization_id: sessionStorage.getItem('organization_id') || ''
      })
    });
    if (!capRoleRes.ok) {
      const txt = await capRoleRes.text();
      throw new Error(`CAP role assign (new user) failed: ${capRoleRes.status} ${txt}`);
    }
  }
}

// Assign Scrubber role if enabled
if (appSelect.scrubber && form.scrubberRole) {
  const scrubberRes = await fetch(`${API_BASE}/app-roles/scrubber`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      user_id: data.userId,
      role: form.scrubberRole,
      organization_id: sessionStorage.getItem('organization_id') || ''
    })
  });
  if (!scrubberRes.ok) {
    const txt = await scrubberRes.text();
    throw new Error(`Scrubber role assign failed: ${scrubberRes.status} ${txt}`);
  }

  // Assign all protocol scopes (compliance admins get all protocols)
  const scopeRes = await fetch(`${API_BASE}/app-roles/scrubber/scopes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      user_id: data.userId,
      protocol_codes: form.scrubberScopes,
      organization_id: sessionStorage.getItem('organization_id') || ''
    })
  });
  if (!scopeRes.ok) {
    const txt = await scopeRes.text();
    throw new Error(`Scrubber scopes assign failed: ${scopeRes.status} ${txt}`);
  }
}

// Assign Risk role (org-wide) if enabled
if (appSelect.risk && form.riskRole) {
  const riskRes = await fetch(`${API_BASE}/app-roles/risk`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      user_id: data.userId,
      role: form.riskRole === 'Compliance Admin' ? 'admin' : 'officer',
      department_id: null,
      scope: 'org'
    })
  });
  if (!riskRes.ok) {
    const txt = await riskRes.text();
    throw new Error(`Risk role assign failed: ${riskRes.status} ${txt}`);
  }
}

if (appSelect.memo) {
  const assignment = form.contractAssignments[0];

  // For our backend, department, contract, and PBP are required for ALL memo roles
  if (
    !form.memoRole ||
    !form.departmentId ||
    !assignment?.contractId ||
    !assignment?.pbpId
  ) {
    console.error('❌ Missing memo role assignment fields');
    setMessage('❌ Fill in memo role, department, contract, and PBP');
    return;
  }

  const memoRes = await fetch(`${API_BASE}/app-roles/memo`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      user_id: data.userId,
      role: form.memoRole,                 // <-- use memoRole
      department_id: form.departmentId,    // <-- required by backend
      contract_id: assignment.contractId,
      pbp_id: assignment.pbpId,
      organization_id: sessionStorage.getItem('organization_id')
    })
  });

  const memoData = await memoRes.json();
  if (!memoData.success) {
    console.error('❌ Failed to assign memo role:', memoData.message);
    setMessage('❌ Failed to assign memo access');
    return;
  }

  console.log('✅ Memo role assigned');
}


  setMessage(`✅ User created: ${form.name} (${form.email})`);
  setForm({
  name: '',
  email: '',
  password: '',
  contractAssignments: [{ contractId: '', pbpId: '' }],
  departmentId: '',
  memoRole: '',
  capRole: '',
  scrubberRole: '',
  scrubberScopes: ['ODAG', 'CDAG', 'FA', 'SNPCC']
});
setCapMatch('same');
setCapPerson({
  name: '',
  email: '',
  password: '',
  departmentId: '',
  contractId: ''
});
setAppSelect({
  memo: selectedApp === 'memo' || !selectedApp,
  cap: selectedApp === 'cap',
  scrubber: selectedApp === 'scrubber'
});

}

 else {
        setMessage(`❌ ${data.message}`);
      }
    } catch (err) {
      console.error('❌ Registration failed:', err);
      setMessage('❌ Something went wrong.');
    }
  };


return (
  <div className="max-w-3xl mx-auto space-y-8">

<h2 className="text-2xl font-semibold text-gray-800 tracking-tight">Register Standalone User</h2>
<p className="text-sm text-gray-500">Add one-off Admins or Associates and assign contracts.</p>

<form className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm space-y-5" onSubmit={handleRegister}>

  {/* App Access Boxes */}
<div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
  {/* Memo Box */}
  <button
    type="button"
    onClick={() => toggleApp('memo')}
    className={`border rounded-lg p-4 text-left transition ${
      appSelect.memo ? 'border-blue-600 ring-2 ring-blue-200 bg-blue-50' : 'border-gray-300 bg-white'
    }`}
  >
    <div className="flex items-center justify-between">
      <h3 className="font-semibold text-gray-800">📄 Memo Access</h3>
      <span className={`text-xs px-2 py-1 rounded ${
        appSelect.memo ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'
      }`}>{appSelect.memo ? 'Enabled' : 'Disabled'}</span>
    </div>
    <p className="text-xs text-gray-500 mt-1">Assign global Admin or Associate with contract + PBP.</p>
  </button>

  {/* CAP Box */}
  <button
    type="button"
    onClick={() => toggleApp('cap')}
    className={`border rounded-lg p-4 text-left transition ${
      appSelect.cap ? 'border-green-600 ring-2 ring-green-200 bg-green-50' : 'border-gray-300 bg-white'
    }`}
  >
    <div className="flex items-center justify-between">
      <h3 className="font-semibold text-gray-800">✅ CAP Access</h3>
      <span className={`text-xs px-2 py-1 rounded ${
        appSelect.cap ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700'
      }`}>{appSelect.cap ? 'Enabled' : 'Disabled'}</span>
    </div>
    <p className="text-xs text-gray-500 mt-1">Assign one CAP role (Owner, Lead, Admin, Developer, Validator, Leader).</p>
  </button>

  {/* Scrubber Box */}
  <button
    type="button"
    onClick={() => toggleApp('scrubber')}
    className={`border rounded-lg p-4 text-left transition ${
      appSelect.scrubber ? 'border-amber-600 ring-2 ring-amber-200 bg-amber-50' : 'border-gray-300 bg-white'
    }`}
  >
    <div className="flex items-center justify-between">
      <h3 className="font-semibold text-gray-800">🧹 Scrubber Access</h3>
      <span className={`text-xs px-2 py-1 rounded ${
        appSelect.scrubber ? 'bg-amber-600 text-white' : 'bg-gray-200 text-gray-700'
      }`}>{appSelect.scrubber ? 'Enabled' : 'Disabled'}</span>
    </div>
    <p className="text-xs text-gray-500 mt-1">Assign Scrubber role with access to all protocols (ODAG, CDAG, FA, SNPCC).</p>
  </button>

  {/* Risk Box */}
  <button
    type="button"
    onClick={() => toggleApp('risk')}
    className={`border rounded-lg p-4 text-left transition ${
      appSelect.risk ? 'border-amber-600 ring-2 ring-amber-200 bg-amber-50' : 'border-gray-300 bg-white'
    }`}
  >
    <div className="flex items-center justify-between">
      <h3 className="font-semibold text-gray-800">⚠️ Risk Access</h3>
      <span className={`text-xs px-2 py-1 rounded ${
        appSelect.risk ? 'bg-amber-600 text-white' : 'bg-gray-200 text-gray-700'
      }`}>{appSelect.risk ? 'Enabled' : 'Disabled'}</span>
    </div>
    <p className="text-xs text-gray-500 mt-1">Assign org-wide Risk Admin or Compliance Officer.</p>
  </button>
</div>

<input
  name="name"
  placeholder="Full Name"
  value={form.name}
  onChange={handleChange}
  required
  className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
/>

<input
  name="email"
  placeholder="Email"
  type="email"
  value={form.email}
  onChange={handleChange}
  required
  className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
/>

<input
  name="password"
  placeholder="Create Password"
  type="password"
  value={form.password}
  onChange={handleChange}
  required
  className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
/>


{appSelect.memo && (
  <select
    name="memoRole"
    value={form.memoRole}
    onChange={handleChange}
    required
    className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
  >
    <option value="">Select Memo Role</option>
    <option value="admin">Compliance Admin</option>
    <option value="associate">Compliance Associate</option>
  </select>
)}

{/* Risk Box */}
{appSelect.risk && (
  <>
    <select
      name="riskRole"
      value={form.riskRole}
      onChange={handleChange}
      required
      className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500"
    >
      <option value="">Select Risk Role</option>
      <option value="Compliance Admin">Compliance Admin (Org-wide)</option>
      <option value="Compliance Officer">Compliance Officer (Org-wide)</option>
    </select>
  </>
)}

{appSelect.cap && (
  <>
    <select
      name="capRole"
      value={form.capRole}
      onChange={handleChange}
      required
      className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
    >
      <option value="">Select CAP Role</option>
      <option value="CAP Owner">CAP Owner</option>
      <option value="CAP Lead">CAP Lead</option>
      <option value="CAP Admin">CAP Admin</option>
      <option value="CAP Developer">CAP Developer</option>
      <option value="CAP Validator">CAP Validator</option>
      <option value="CAP Leader">CAP Leader</option>
    </select>

    {/* CAP Matching: same person vs new person */}
    <div className="mt-3 border rounded p-3 bg-gray-50">
      <label className="block text-sm font-medium text-gray-700 mb-2">CAP User Match</label>
      <div className="flex items-center gap-4">
        <label className="inline-flex items-center gap-2 text-sm">
          <input
            type="radio"
            name="capMatch"
            value="same"
            checked={capMatch === 'same'}
            onChange={() => setCapMatch('same')}
          />
          Use the same person as above (Memo)
        </label>
        <label className="inline-flex items-center gap-2 text-sm">
          <input
            type="radio"
            name="capMatch"
            value="new"
            checked={capMatch === 'new'}
            onChange={() => setCapMatch('new')}
          />
          Create a separate CAP person
        </label>
      </div>

      {capMatch === 'new' && (
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
          <input
            name="name"
            placeholder="CAP Full Name"
            value={capPerson.name}
            onChange={handleCapPersonChange}
            required
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
          />
          <input
            name="email"
            placeholder="CAP Email"
            type="email"
            value={capPerson.email}
            onChange={handleCapPersonChange}
            required
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
          />
          <input
            name="password"
            placeholder="CAP Password"
            type="password"
            value={capPerson.password}
            onChange={handleCapPersonChange}
            required
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
          />

          <select
            name="departmentId"
            value={capPerson.departmentId}
            onChange={handleCapPersonChange}
            required
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select CAP Department</option>
            {departments.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name} {Array.isArray(d.aliases) && d.aliases.length > 0 ? `(${d.aliases.join(', ')})` : ''}
              </option>
            ))}
          </select>

          <select
            name="contractId"
            value={capPerson.contractId}
            onChange={handleCapPersonChange}
            required
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select CAP Contract</option>
            {contracts.map((c) => (
              <option key={c.id} value={c.id}>
                {c.contract_id || c.id} – {c.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  </>
)}

{appSelect.scrubber && (
  <>
    <select
      name="scrubberRole"
      value={form.scrubberRole}
      onChange={handleChange}
      required
      className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500"
    >
      <option value="">Select Scrubber Role</option>
      <option value="analyst">Analyst</option>
      <option value="supervisor">Supervisor</option>
      <option value="admin">Admin</option>
    </select>

    <div className="mt-3 border rounded p-3 bg-amber-50">
      <label className="block text-sm font-medium text-gray-700 mb-2">Protocol Access</label>
      <p className="text-xs text-gray-600 mb-3">Compliance admins have access to all protocols by default.</p>
      <div className="grid grid-cols-2 gap-2">
        <div className="flex items-center">
          <input
            type="checkbox"
            checked={form.scrubberScopes.includes('ODAG')}
            disabled
            className="mr-2 rounded border-gray-300 bg-gray-100 text-amber-500"
          />
          <span className="text-sm text-gray-700">ODAG</span>
        </div>
        <div className="flex items-center">
          <input
            type="checkbox"
            checked={form.scrubberScopes.includes('CDAG')}
            disabled
            className="mr-2 rounded border-gray-300 bg-gray-100 text-amber-500"
          />
          <span className="text-sm text-gray-700">CDAG</span>
        </div>
        <div className="flex items-center">
          <input
            type="checkbox"
            checked={form.scrubberScopes.includes('FA')}
            disabled
            className="mr-2 rounded border-gray-300 bg-gray-100 text-amber-500"
          />
          <span className="text-sm text-gray-700">FA</span>
        </div>
        <div className="flex items-center">
          <input
            type="checkbox"
            checked={form.scrubberScopes.includes('SNPCC')}
            disabled
            className="mr-2 rounded border-gray-300 bg-gray-100 text-amber-500"
          />
          <span className="text-sm text-gray-700">SNPCC</span>
        </div>
      </div>
    </div>
  </>
)}



{showDepartmentField && (
  <select
  name="departmentId"
  value={form.departmentId}
  onChange={handleChange}
  required
  className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
>

    <option value="">Select Department</option>
    {departments.map((d) => (
      <option key={d.id} value={d.id}>
        {d.name} {Array.isArray(d.aliases) && d.aliases.length > 0 ? `(${d.aliases.join(', ')})` : ''}
      </option>
    ))}
  </select>
)}


        {form.contractAssignments.map((assignment, idx) => (
<div key={idx} className="grid grid-cols-12 gap-4 items-center">
            <select
  value={assignment.contractId}
  onChange={(e) => handleAssignmentChange(idx, 'contractId', e.target.value)}
  required
  className="col-span-5 border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
>

              <option value="">Select Contract</option>
              {contracts.map(c => (
                <option key={c.id} value={c.id}>
                  {c.contract_id} – {c.name}
                </option>
              ))}
            </select>

<select
  value={assignment.pbpId}
  onChange={(e) => handleAssignmentChange(idx, 'pbpId', e.target.value)}
  required
  className="col-span-5 border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
>

              <option value="">Select PBP</option>
              {(pbpsByContract[assignment.contractId] || []).map((p, i) => (
<option key={p.id} value={p.id}>{p.pbp}</option>

              ))}
            </select>

<button
  type="button"
  onClick={() => removeAssignment(idx)}
  className="col-span-2 text-red-500 hover:text-red-700 text-sm"
>
  ➖ Remove
</button>

          </div>
        ))}

<button
  type="button"
  onClick={addAssignment}
  className="text-blue-600 hover:text-blue-800 text-sm font-medium"
>
  ➕ Add Contract
</button>

<button
  type="submit"
  className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded px-4 py-2"
>
  Register User
</button>
{message && (
  <p className="text-sm font-medium text-blue-600 mt-2">
    {message}
  </p>
)}
      </form>
    </div>
  );
}

export default RegisterSimple;
